import * as scheduleBlockActions from 'action/scheduleBlock'
import * as spinnerActions from 'action/spinner'
import * as weeklyBlockActions from 'action/weeklyBlock'
import Button from 'component/Button'
import Checkbox from 'component/Checkbox/newCheckbox'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import Modal from 'component/Modal/GenericModal'
import SuccessModal from 'component/Modal/SuccessModal'
import Select from 'component/Select/Select'
import TextField from 'component/TextField'
import Pagination from 'component/pagination/Pagination'
import WarningModal from 'component/scheduleBlock/WarningModal'
import CloseIconSVG from 'component/svgComponents/close'
import FilterIconSVG from 'component/svgComponents/filter'
import Col from 'component/utils/Col'
import ContentHeader from 'component/utils/ContentHeader'
import Grid from 'component/utils/Grid'
import Notification from 'component/utils/Notification'
import Row from 'component/utils/Row'
import API_URL from 'constants/api'
import { isArray, isEqual } from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import SizeSelect from 'react-select'
import { ToastContainer } from 'react-toastify'
import { bindActionCreators } from 'redux'
import Api from 'utils/ApiRequest'
import { colourStyles } from 'utils/selectStyle'
import { isEmpty, objectsEqual } from 'utils/validations'
import CustomBranchSelect from './CustomBranchSelect'
import NewTable from './Table'
import TextArea from 'component/TextArea'
import "./styles.css"

const PAGINATION_OPTIONS = [
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '30', value: 30 },
  { label: '40', value: 40 },
  { label: '50', value: 50 },
]

class ScheduleBlockContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    error: PropTypes.object,
    updated: PropTypes.bool,
    deleted: PropTypes.bool,
    deletedError: PropTypes.object,
    scheduleBlocks: PropTypes.array.isRequired,
    branchs: PropTypes.array,
    updateScheduleBlock: PropTypes.func.isRequired,
    fetchScheduleBlock: PropTypes.func.isRequired,
    deleteScheduleBlock: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    weeklyBlock: PropTypes.object,
    fetchWeeklyBlock: PropTypes.func.isRequired,
    accordionOpen: PropTypes.bool,
    updateWeeklyBlock: PropTypes.func.isRequired,
    weeklyBlockError: PropTypes.object,
    isUserMatriz: PropTypes.bool,
    showSpinner: PropTypes.func,
    hideSpinner: PropTypes.func,
    user: PropTypes.object,

  }

  constructor(props) {
    super(props)

    this.state = {
      idBranch: {},
      renderError: false,
      placeholderError: '',
      storesFilterVisible: false,
      editModalOpen: false,
      stores: [],
      editMode: false,
      warningModal: false,
      warningModalWeekly: false,
      weeklyModal: false,
      filterForm: {
        idBranch: [],
        inRepeatAnnually: null,
        dtPeriod: '',
        wareHouseId: ''
      },
      savedFilterData: {
        idBranch: [],
        inRepeatAnnually: null,
        dtPeriod: '',
        wareHouseId: ''
      },
      dateResetKey: 0,
      newPeriodBlockFormData: {
        idBranch: [],
        dsScheduleBlock: '',
        dsReasonScheduleBlock: '',
        dtPeriod: '',
        inRepeatAnnually: false,
        wareHouseId: ''
      },
      newWeeklyBlockFormData: {
        idBranch: [],
        inSunday: 0,
        inMonday: 0,
        inTuesday: 0,
        inWednesday: 0,
        inThursday: 0,
        inFriday: 0,
        inSaturday: 0,
        wareHouseId: ''
      },
      pagination: {
        page: 1,
        size: 10,
      },
      orderDirection: 'desc',
      renderExistentModal: false,
      missionsSelectBranchs: []
    }
  }

  componentDidMount() {
    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }
    this.getParameter(params).then(resp => {
      const missions = resp.data.split(",")
      this.setState({missionsSelectBranchs: missions}, () => this.fetchStores())
    })
  }

  getParameter(values) {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values)

  }

  weeklyBlockValidation() {
    const { weeklyBlock } = this.props
    const {
      newWeeklyBlockFormData: {
        idBranch,
        inSunday,
        inMonday,
        inTuesday,
        inWednesday,
        inThursday,
        inFriday,
        inSaturday,
        wareHouseId,
      }
    } = this.state

    let requiredEmpty = false
    let sameValues = true

    if (!objectsEqual(weeklyBlock, {
      inSunday,
      inMonday,
      inTuesday,
      inWednesday,
      inThursday,
      inFriday,
      inSaturday,
    })) {
      sameValues = false
    }

    if (idBranch.length === 0 || wareHouseId.length === 0) {
      requiredEmpty = true
    }

    return requiredEmpty || sameValues
  }

  fetchStores = async () => {
    const {
      auth: { user },
      showSpinner,
      hideSpinner
    } = this.props
    const { filterForm } = this.state

    if (user) {
      showSpinner()
      this.setState({ loading: true })

      try {
        const { data } = await new Api(user.dsToken).post(API_URL.BRANCHES)

        this.setState(
          {
            filterForm: { ...filterForm, idBranch: data.map(({ id }) => id) },
            stores: data.map(({ id, name }) => ({ id, name })),
          },
          () => {
            hideSpinner()
            this.handleFilters()
          }
        )
      } catch (error) {
        hideSpinner()
      }
    }
  }

  setSuccessModalMsg = (msg) => this.setState({ successModalMsg: msg })

  componentDidUpdate(prevProps) {
    const { updated, deleted, error } =
      this.props
    const {
      pagination: { page, size }
    } = this.state

    if (updated !== prevProps.updated && updated) {
      this.setSuccessModalMsg('scheduleBlock.updateScheduleBlock-success')
      this.handleFetchScheduleBlock(page, size)
    }

    if (deleted !== prevProps.deleted && deleted) {
      this.setSuccessModalMsg('scheduleBlock.deleteScheduleBlock-success')
      this.handleFetchScheduleBlock(page, size)
    }
    if (error && error.cdStatus === 400 && error !== prevProps.error) this.setState({ renderExistentModal: true })
  }

  renderWarningModalWeekly = () => {

    if (!this.state.warningModalWeekly) return



    const handleConfirm = () => {
      this.setState({warningModalWeekly: false},() => this.clearForms())
    }

    const handleCancel = () => {
      this.setState({warningModalWeekly: false}, () => {
        this.setState({weeklyModal: true})
      })

    }

    return (
      <WarningModal
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        translate={this.props.translate}
      />
    )

  }

  renderWarningModal = () => {
    if (!this.state.warningModal) return



    const handleConfirm = () => {
      this.setState({warningModal: false})
    }

    const handleCancel = () => {
      this.setState({warningModal: false}, () => {
        this.setState({editModalOpen: true})
      })

    }

    return (
      <WarningModal
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        translate={this.props.translate}
      />
    )
  }

  handleFilters = () => {
    const {
      filterForm,
      pagination: { size },
    } = this.state
    if (filterForm.idBranch.length === 0) {
      this.setState({
        renderError: true,
        placeholderError: 'scheduleBlock.placeholderError',
      })
    }

    this.handleFetchScheduleBlock(1, size).then(() =>
      this.setState({ sideFilterVisible: false, savedFilterData: filterForm })
    )
  }

  resetFilters = () => {
    const { stores } = this.state
    const { isUserMatriz, user } = this.props
    const { missionsSelectBranchs } = this.state

    const defaultFilterForm = {
      idBranch: (!isUserMatriz && !missionsSelectBranchs.includes(user.title)) 
        ? [user.locationCode.padStart(4, '0')]
        : stores.map(({ id }) => id),
      inRepeatAnnually: null,
      dtPeriod: null,
      wareHouseId: ''
    }

    this.setState({
      filterForm: defaultFilterForm,
      renderError: false,
      dateResetKey: this.state.dateResetKey + 1,
    }, () => {
      setTimeout(() => {
        if (stores.length > 0) {
          const allBranches = (!isUserMatriz && !missionsSelectBranchs.includes(user.title)) 
            ? [user.locationCode.padStart(4, '0')]
            : stores.map(({ id }) => id)
          this.setState({
            filterForm: {
              ...this.state.filterForm,
              idBranch: allBranches,
            },
          })
        }
      }, 0)
    })
  }

  handleFetchScheduleBlock = (page = 1, size = 10) => {
    const { fetchScheduleBlock, auth } = this.props

    const {
      filterForm: {
        idBranch,
        inRepeatAnnually,
        dtPeriod,
        wareHouseId
      },
      orderDirection,
    } = this.state

    const [dtBegin, dtEnd] = isArray(dtPeriod) ? dtPeriod : []
    this.setState({
      pagination: { page, size}
    })

    // Prepare warehouse filter: send array if multiple, single value if one, or undefined if none
    const warehouseFilter = isArray(wareHouseId) && wareHouseId.length > 0 
      ? (wareHouseId.length === 1 ? { wareHouseId: wareHouseId[0] } : { wareHouseIds: wareHouseId })
      : (wareHouseId ? { wareHouseId } : {})
    
    return fetchScheduleBlock(auth, {
      idBranch,
      inRepeatAnnually,
      dtBegin: dtBegin ? dtBegin.startOf('day').format() : '',
      dtEnd: dtEnd ? dtEnd.endOf('day').format() : '',
      ...warehouseFilter,
    }, page, size, orderDirection)

  }

  getPage = (page) => {
    const { pagination } = this.state

    this.setState({
      pagination: { ...pagination, page },
    })

    this.handleFetchScheduleBlock(page, pagination.size)
  }

  getSize = (size) => {
    this.setState({
      pagination: { page: 1, size },
    })

    this.handleFetchScheduleBlock(1, size)
  }

  handleOrderDirection=()=>{
    this.setState(prevState=>({
      orderDirection: prevState.orderDirection === 'desc' ? 'asc' : 'desc'
    }), ()=>{
      this.handleFetchScheduleBlock();
    });
  }

  handleSave = () => {
    const { updateScheduleBlock, auth } = this.props

    const {
      newPeriodBlockFormData: {
        idBranch,
        dsScheduleBlock,
        dsReasonScheduleBlock,
        dtPeriod: [dtBegin, dtEnd],
        inRepeatAnnually,
        wareHouseId,
        ...rest
      }
    } = this.state

    updateScheduleBlock(
      auth,
      {
        idBranch,
        dsScheduleBlock,
        dsReasonScheduleBlock: dsReasonScheduleBlock.trimStart(),
        dtBegin: dtBegin.format(),
        dtEnd: dtEnd.format(),
        inRepeatAnnually: inRepeatAnnually ? 1 : 0,
        wareHouseId : '',
        types: wareHouseId,
        ...rest
      },
      () => this.clearForms()
    )
  }

  handleDelete = (idScheduleBlock, idBranch = []) => {
    const { deleteScheduleBlock, auth } = this.props

    const toRemove = {
      idScheduleBlock,
      idBranch: idBranch.map(({ idBranch }) => idBranch),
    }

    deleteScheduleBlock(auth, toRemove)
  }

  handleFetchWeeklyBlock = () => {
    const { fetchWeeklyBlock, auth } = this.props

    const {
      newWeeklyBlockFormData: { idBranch, wareHouseId },
    } = this.state



    if ((idBranch || '').length && (wareHouseId || '').length) fetchWeeklyBlock(auth, { idBranch, wareHouseIds: wareHouseId }).then(() => {
      const { weeklyBlock } = this.props


      this.setState({
        newWeeklyBlockFormData: {
          idBranch,
          ...weeklyBlock,
          wareHouseId,

        },
      })
    })
    else this.setState({
      newWeeklyBlockFormData: {
        idBranch,
        wareHouseId,
        inSunday: 0,
        inMonday: 0,
        inTuesday: 0,
        inWednesday: 0,
        inThursday: 0,
        inFriday: 0,
        inSaturday: 0,
      },
    })
  }

  clearForms = (callback) => {
    this.setState(
      {
        editMode: false,
        editModalOpen: false,
        newPeriodBlockFormData: {
          idBranch: [],
          dsScheduleBlock: '',
          dsReasonScheduleBlock: '',
          dtPeriod: '',
          inRepeatAnnually: false,
          wareHouseId: []
        },
        newWeeklyBlockFormData: {
          idBranch: [],
          inSunday: 0,
          inMonday: 0,
          inTuesday: 0,
          inWednesday: 0,
          inThursday: 0,
          inFriday: 0,
          inSaturday: 0,
          wareHouseId: ''
        },
      },
      () => callback && callback()
    )
  }

  handleCheckboxChange = (e) => {
    const { newPeriodBlockFormData } = this.state

    this.setState({
      newPeriodBlockFormData: {
        ...newPeriodBlockFormData,
        inRepeatAnnually: e ? 1 : 0,
      },
    })
  }

  handleUpdateWeeklyBlock = () => {
    const { updateWeeklyBlock, auth } = this.props
    const {newWeeklyBlockFormData} = this.state

    const params =  newWeeklyBlockFormData.wareHouseId.map(wareHouse => ({
        ...newWeeklyBlockFormData,
        wareHouseId: wareHouse,
        isNexp: wareHouse === "Nexp",
        isNegative: wareHouse === 'Negativo'
      }))



    updateWeeklyBlock(auth, params, () =>
      this.clearForms(() =>
        this.setState({weeklyModal: false}, () => this.setSuccessModalMsg('scheduleBlock.updateScheduleBlock-success'))
      )
    )
  }

  renderNotification = () => {
    const { translate } = this.props
    return (
      <Notification
        className='notification-warning notification-warning-mission margin-top'
        message={translate('scheduleBlock.not-found')}
      />
    )
  }

  handleOpenEditModal = ({ listScheduleBlockBranchsModel, dtBegin, dtEnd, dsScheduleBlock, dsReasonScheduleBlock, inRepeatAnnually, wareHouseId, ...rest }) => {

    const parsedData = {
      ...rest,
      wareHouseId: [wareHouseId],
      idBranch: (listScheduleBlockBranchsModel || []).map(
        ({ idBranch }) => idBranch
      ),
      dtPeriod: [moment(dtBegin), moment(dtEnd)],
      dsScheduleBlock,
      dsReasonScheduleBlock: !isEmpty(dsReasonScheduleBlock.trimStart()) ? dsReasonScheduleBlock : dsScheduleBlock,
      inRepeatAnnually,
    }

    this.setState({
      editMode: true,
      editModalOpen: true,
      editDataCopy: parsedData,
      newPeriodBlockFormData: parsedData,
    })
  }

  renderExistentModal = () => {
    const { translate } = this.props

    return (
      <Modal
        size='sm'
        showHeader={false}
        onConfirm={() => this.setState({ renderExistentModal: false })}
        onCloseModal={() =>
          this.clearForms(() => this.setState({ editModalOpen: false, renderExistentModal: false }))
        }
        isOpen
        disabledBgClickClosing
        noCloseOnConfirm
        confirmButtonText={translate('newLogin.errorModal.button.label')}
        center
        className='schedule-block-edit-modal schedule-padding'
        cancelButtonText={translate('close_button_label')}
      >
        <div className='remove-modal no-padding'>
          <h3 className='text-left no-margin'><strong>{translate('duplicateRegister')}</strong></h3>
          <span className='title text-left margin-top'>
            {translate('scheduleBlock.existentMessage.1')}
          </span>
          <span className='title text-left margin-top'>
            {translate(
              'scheduleBlock.existentMessage.2'
            )}
          </span>
        </div>
      </Modal>
    )
  }

  render() {
    const {
      translate,
      scheduleBlocks,
      pages,
      count,
      current,
      auth: { user },
      isUserMatriz
    } = this.props

    const {
      renderError,
      sideFilterVisible,
      newPeriodBlockFormData,
      newWeeklyBlockFormData,
      editModalOpen,
      stores,
      filterForm,
      editDataCopy,
      editMode,
      weeklyModal,
      successModalMsg,
      pagination: { size },
      savedFilterData,
      renderExistentModal
    } = this.state

    const filterRepeatOptions = [
      { value: null, label: translate('ruptures.allBranches') },
      { value: 1, label: translate('scheduleBlock.inRepeatAnnually.annually') },
      { value: 0, label: translate('scheduleBlock.inRepeatAnnually.once') },
    ]

    const wareHouseOptions = ['C050', 'C010','ghost'].map(option => ({ label: translate('warehouse.option.'.concat(option)), value: option }))
    const wareHouseOptionsWithNexp = [...wareHouseOptions.filter(a => a.value !== 'ghost'), {label: "Nexp", value: "Nexp"}, {label: "Negativo", value: "Negativo"}, {label:"Fantasma", value: "Fantasma"}]

    const missingRequired =
      !newPeriodBlockFormData.idBranch.length ||
      !newPeriodBlockFormData.dsScheduleBlock ||
      !newPeriodBlockFormData.dsReasonScheduleBlock ||
      !newPeriodBlockFormData.dtPeriod ||
      !newPeriodBlockFormData.wareHouseId || isEmpty(newPeriodBlockFormData.wareHouseId)

    return (
      <section>
        {successModalMsg && (
          <SuccessModal
            t={translate}
            msg={translate(successModalMsg)}
            size='sm'
            fillButton
            buttonText='OK'
            center
            handleClose={() => {
              this.setState({ successModalMsg: false })
            }}
          />
        )}
        {sideFilterVisible && (
          <>
            <div className='bg-filter' />
            <div className='right-filter-container'>
              <CloseIconSVG
                className ="right-filter-svg"
                onClick={() => this.setState({ sideFilterVisible: false, filterForm: savedFilterData })}
              />
              <h3 className='margin-bottom-triple'>
                <strong>{translate('mobile.filter')}</strong>
              </h3>
              <Row className='w-100'>
                <Select
                  className='w-100'
                  required
                  label={translate('schedule.block.type')}
                  value={ filterForm.wareHouseId ? wareHouseOptions.filter((option) => filterForm.wareHouseId.some(value => option.value === value)): ''}
                  options={wareHouseOptions}
                  isMulti
                  onChange={(e) => {
                    if(isEmpty(e)) { this.setState({filterForm: {...filterForm, wareHouseId: ''}})}
                    if(Object.values(e).length > 1) {
                      const multipleOptions = Object.values(e).map(option => option.value)
                      this.setState({filterForm: {...filterForm, wareHouseId: multipleOptions}})
                    }  else if(!isEmpty(e)) {
                        const optionSelected = e[0]
                        this.setState({filterForm: {...filterForm, wareHouseId: [optionSelected.value]}})
                    }
                  }}
                  fill
                  placeholder={translate('stock.select')}
                />
              </Row>
              <Row className='w-100'>
                <Col>
                  <CustomBranchSelect
                    className='w-100'
                    value={ (!isUserMatriz && !this.state.missionsSelectBranchs.includes(user.title)) ? stores
                      .filter(({ id }) => id === user.locationCode.padStart(4, '0'))
                      .map(({ id, name }) => ({
                        value: id,
                        label: `${id} - ${name}`,
                      })) : stores
                    .filter(({ id }) => filterForm.idBranch.includes(id))
                    .map(({ id, name }) => ({
                      value: id,
                      label: `${id} - ${name}`,
                    }))}
                    label={translate('rotativeInventory.dsBranch')}
                    fill
                    required
                    onChange={(e) =>
                      this.setState({
                        filterForm: {
                          ...filterForm,
                          idBranch: e.target.value.map(({ value }) => value),
                        },
                      })
                    }
                    disabled={!isUserMatriz && (!this.state.missionsSelectBranchs.includes(user.title))}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Select
                    required
                    label={translate('scheduleBlock.repetition')}
                    value={
                      typeof filterForm.inRepeatAnnually === 'number'
                        ? filterRepeatOptions.find(
                          (opt) => opt.value === filterForm.inRepeatAnnually
                        )
                        : filterRepeatOptions[0]
                    }
                    options={filterRepeatOptions}
                    onChange={({ value }) =>
                      this.setState({
                        filterForm: { ...filterForm, inRepeatAnnually: value },
                      })
                    }
                  />
                </Col>
              </Row>
              <Row className='w-100'>
                <NewDateIntervalInput
                  key={`date-input-${this.state.dateResetKey}`}
                  required
                  user={user}
                  validate={false}
                  label={translate('field.period.hint')}
                  name='dtPeriod'
                  t={translate}
                  reset={!filterForm.dtPeriod}
                  onChange={(e) => {
                    this.setState({
                      filterForm: {
                        ...filterForm,
                        dtPeriod: e,
                      },
                    })
                  }}
                  initialValue={filterForm.dtPeriod}
                />
              </Row>
              <Row>
                <Col xs={12} className='margin-bottom margin-top no-padding'>
                  <div style={{ marginTop: '30px' }} className='flex flex-row gap-filters'>
                    <button
                      className='btn btn-danger-outline full-w'
                      onClick={this.resetFilters}>
                      {translate('suggestions.cleanFilters')}
                    </button>
                    <button
                      className='btn btn-primary full-w'
                      disabled={!filterForm.idBranch.length}
                      onClick={this.handleFilters}>
                      {translate('filter_button_label')}
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        )}
        <ContentHeader>{translate('scheduleBlock.title')}</ContentHeader>
        <div className='float-right margin-top margin-right'>
          <Modal
            className="schedule-block-new-modal"
            title={translate(
              editMode ? 'scheduleBlock.edit' : 'scheduleBlock.new'
            )}
            overflow='visible'
            onConfirm={this.handleSave}
            isOpen={editModalOpen}
            useControlledState
            confirmButtonText={translate('justifications.register')}
            cancelButtonText={translate('buttom.help.config.view')}
            isConfirmButtonDisabled={
              editMode
                ? isEqual(editDataCopy, newPeriodBlockFormData) ||
                missingRequired
                : missingRequired
            }
            onCloseModal={() => {
              const anyField = Object.values(newPeriodBlockFormData).filter(value => !isEmpty(value)).length > 1

              if(!editMode && anyField) {
                this.setState({warningModal: true}, () => this.setState({editModalOpen: false}))
                return
              }

              if(editMode && isEqual(editDataCopy, newPeriodBlockFormData)) {
                this.setState({editModalOpen: false})
                return
              }

              if(editMode && !isEqual(editDataCopy, newPeriodBlockFormData)) {
                this.setState({warningModal: true}, () => this.setState({editModalOpen: false}))
                 return
              }
              this.setState({editModalOpen: false})
            }

            }
            renderButton={() => (
              <Button
                className='btn btn-primary margin-right'
                text={translate('scheduleBlock.new')}
                onClick={() =>
                  this.clearForms(() => this.setState({ editModalOpen: true }))
                }
              />
            )}
          >
            <Row className='w-100'>
              <Select
                className='w-100'
                required
                isMulti
                label={translate('schedule.block.type')}
                value={newPeriodBlockFormData.wareHouseId ? wareHouseOptions.filter((option) => newPeriodBlockFormData.wareHouseId.some(value => option.value === value)): ''}
                options={wareHouseOptions}
                onChange={(values ) => {

                  const multipleOptions = !isEmpty(values) ? Object.values(values).map(option => option.value) : []
                  this.setState({
                    newPeriodBlockFormData: {
                      ...newPeriodBlockFormData,
                      wareHouseId: multipleOptions,
                    },
                  })
                }


                }
                disabled={editMode}
                fill
                placeholder={translate('stock.select')}
              />
            </Row>
            <Row className='w-100'>
              <CustomBranchSelect
                className='w-100'
                value={stores
                  .filter(({ id }) =>
                    newPeriodBlockFormData.idBranch.includes(id)
                  )
                  .map(({ id, name }) => ({
                    value: id,
                    label: `${id} - ${name}`,
                  }))}
                label={
                  newPeriodBlockFormData.idBranch.length
                    ? translate('mobile.hint.store')
                    : translate('rotativeInventory.dsBranch')
                }
                fill
                required
                onChange={(e) =>
                  this.setState({
                    newPeriodBlockFormData: {
                      ...newPeriodBlockFormData,
                      idBranch: e.target.value.map(({ value }) => value),
                    },
                  })
                }
                disabled={newPeriodBlockFormData.wareHouseId.length === 0}
                excludeInactive={true}
              />
            </Row>
            <Row className='w-100'>
              <TextField
                controlled
                value={newPeriodBlockFormData.dsScheduleBlock}
                validateValue={() => true}
                onChange={(e) => {

                  const {value} = e.target;
                  // Check if the value is not just spaces
                  if (value.trim().length > 0 || value.length === 0) {

                    this.setState({
                      newPeriodBlockFormData: {
                        ...newPeriodBlockFormData,
                        dsScheduleBlock: value,
                      },
                    });
                  }
                }}
                required
                label={"Título"}
                fill
                placeholder={"Digite o título"}
                maxLength={40}
              />
            </Row>


            <Row className='w-100'>

              <TextArea
                  controlled
                  value={newPeriodBlockFormData.dsReasonScheduleBlock}
                  label={translate("scheduleBlock.reason")}
                  required
                  placeholder={translate("scheduleBlock.typeReason")}
                  onChange={(e) => {

                    // Check if the value is not just spaces
                    if (e.trim().length > 0 || e.length === 0) {
                      this.setState({
                        newPeriodBlockFormData: {
                          ...newPeriodBlockFormData,
                          dsReasonScheduleBlock: e,
                        },
                      });
                    }
                  }}
                />
            </Row>


            <Row className='w-100'>
              <NewDateIntervalInput
                required
                validate={false}
                label={translate('field.period.hint')}
                name='dtPeriod'
                t={translate}
                onChange={(e) => {
                  this.setState({
                    newPeriodBlockFormData: {
                      ...newPeriodBlockFormData,
                      dtPeriod: e,
                    },
                  })
                }}
                initialValue={newPeriodBlockFormData.dtPeriod}
                noSelect
                minDate={moment().toDate()}
              />
            </Row>
            <Row className='w-100'>
              <Checkbox
                type='checkbox'
                onChange={(e) => this.handleCheckboxChange(e)}
                label={translate('scheduleBlock.inRepeatAnnually')}
                checked={newPeriodBlockFormData.inRepeatAnnually}
              />
            </Row>
          </Modal>

          <Modal

            isConfirmButtonDisabled={this.weeklyBlockValidation()}
            confirmButtonText={translate('buttom.help.config.edit')}
            isOpen={weeklyModal}
            useControlledState
            cancelButtonText={translate('buttom.help.config.view')}
            onCloseModal={() => {

          
              const typeAndBranchHasValues = !isEmpty(newWeeklyBlockFormData.wareHouseId) && !isEmpty(newWeeklyBlockFormData.idBranch)
              if(typeAndBranchHasValues && !this.weeklyBlockValidation())
                this.setState({warningModalWeekly: true}, () => this.setState({weeklyModal: false}))
              else
                this.clearForms(() => this.setState({weeklyModal: false}))
            }}
            onConfirm={this.handleUpdateWeeklyBlock}
            overflow='visible'

            title={translate('scheduleBlock.new.weekly')}

          >
            <Row className='w-100'>
              <Select
                className='w-100'
                required
                isMulti
                label={translate('schedule.block.type')}
                value={newWeeklyBlockFormData.wareHouseId ? wareHouseOptionsWithNexp.filter((option) => newWeeklyBlockFormData.wareHouseId.some(value => option.value === value)): ''}
                options={wareHouseOptionsWithNexp}
                onChange={(values) =>
                  this.setState({
                    newWeeklyBlockFormData: {
                      ...newWeeklyBlockFormData,
                      wareHouseId: !isEmpty(values) ? Object.values(values).map(option => option.value) : [],
                    },
                  }, () => {

                    if (newWeeklyBlockFormData.idBranch.length !== 0) {
                      this.handleFetchWeeklyBlock()
                    }
                  })
                }
                fill
                placeholder={translate('stock.select')}
              />
            </Row>
            <Row className='w-100'>
              <CustomBranchSelect
                className='w-100'
                value={stores
                  .filter(({ id }) =>
                    newWeeklyBlockFormData.idBranch.includes(id)
                  )
                  .map(({ id, name }) => ({
                    value: id,
                    label: `${id} - ${name}`,
                  }))}
                label={
                  newWeeklyBlockFormData.idBranch.length
                    ? translate('mobile.hint.store')
                    : translate('rotativeInventory.dsBranch')
                }
                fill
                required
                onChange={(e) =>
                  this.setState(
                    {
                      newWeeklyBlockFormData: {
                        ...newWeeklyBlockFormData,
                        idBranch: e.target.value.map(({ value }) => value),
                      },
                    },
                    () => {
                      if (newWeeklyBlockFormData.wareHouseId.length !== 0) {
                        this.handleFetchWeeklyBlock()
                      }
                    }
                  )
                }
                disabled={newWeeklyBlockFormData.wareHouseId.length === 0}
                excludeInactive={true}
              />
            </Row>
            <Row className='w-100'>
              <Col xs={6} className='no-padding'>
                <Checkbox
                  checked={newWeeklyBlockFormData.inMonday}
                  onChange={(e) =>
                    this.setState({
                      newWeeklyBlockFormData: {
                        ...newWeeklyBlockFormData,
                        inMonday: e ? 1 : 0,
                      },
                    })
                  }
                  label={translate('weeklyBlock.inMonday')}
                />
              </Col>
              <Col xs={6} className='no-padding'>
                <Checkbox
                  checked={newWeeklyBlockFormData.inFriday}
                  onChange={(e) =>
                    this.setState({
                      newWeeklyBlockFormData: {
                        ...newWeeklyBlockFormData,
                        inFriday: e ? 1 : 0,
                      },
                    })
                  }
                  label={translate('weeklyBlock.inFriday')}
                />
              </Col>
            </Row>
            <Row className='w-100'>
              <Col xs={6} className='no-padding'>
                <Checkbox
                  checked={newWeeklyBlockFormData.inTuesday}
                  onChange={(e) =>
                    this.setState({
                      newWeeklyBlockFormData: {
                        ...newWeeklyBlockFormData,
                        inTuesday: e ? 1 : 0,
                      },
                    })
                  }
                  label={translate('weeklyBlock.inTuesday')}
                />
              </Col>
              <Col xs={6} className='no-padding'>
                <Checkbox
                  checked={newWeeklyBlockFormData.inSaturday}
                  onChange={(e) =>
                    this.setState({
                      newWeeklyBlockFormData: {
                        ...newWeeklyBlockFormData,
                        inSaturday: e ? 1 : 0,
                      },
                    })
                  }
                  label={translate('weeklyBlock.inSaturday')}
                />
              </Col>
            </Row>
            <Row className='w-100'>
              <Col xs={6} className='no-padding'>
                <Checkbox
                  checked={newWeeklyBlockFormData.inWednesday}
                  onChange={(e) =>
                    this.setState({
                      newWeeklyBlockFormData: {
                        ...newWeeklyBlockFormData,
                        inWednesday: e ? 1 : 0,
                      },
                    })
                  }
                  label={translate('weeklyBlock.inWednesday')}
                />
              </Col>
              <Col xs={6} className='no-padding'>
                <Checkbox
                  checked={newWeeklyBlockFormData.inSunday}
                  onChange={(e) =>
                    this.setState({
                      newWeeklyBlockFormData: {
                        ...newWeeklyBlockFormData,
                        inSunday: e ? 1 : 0,
                      },
                    })
                  }
                  label={translate('weeklyBlock.inSunday')}
                />
              </Col>
            </Row>
            <Row className='w-100'>
              <Col xs={12} className='no-padding'>
                <Checkbox
                  checked={newWeeklyBlockFormData.inThursday}
                  onChange={(e) =>
                    this.setState({
                      newWeeklyBlockFormData: {
                        ...newWeeklyBlockFormData,
                        inThursday: e ? 1 : 0,
                      },
                    })
                  }
                  label={translate('weeklyBlock.inThursday')}
                />
              </Col>
            </Row>
          </Modal>

          <Button
            className='btn btn-secondary margin-right'
            text={translate('scheduleBlock.new.weekly')}
            onClick={() => this.setState({ weeklyModal: true })}

          />

          <Button
            className='btn btn-secondary'
            text={'Filtro'}
            onClick={() => this.setState({ sideFilterVisible: true })}
            svgIcon
            svgComponent={ <FilterIconSVG newDesign={false} className="margin-default-svg" /> }
          />
        </div>
        <Grid fluid>
          <Row className='container-flex divided-list'>
            <Col xs={12} sm={12} md={12} className='show-first-on-mobile'>
              {isEmpty(scheduleBlocks) ? (
                this.renderNotification()
              ) : (
                <NewTable
                  handleDelete={this.handleDelete}
                  translate={translate}
                  records={scheduleBlocks}
                  editEntry={this.handleOpenEditModal}
                  storeList={stores}
                  handleOrderDirection={()=> this.handleOrderDirection()}

                />
              )}
            </Col>
          </Row>

          {(scheduleBlocks.length >= 10 || pages > 1) && (
            <Row>
              <Col className='align-center margin-bottom margin-top new-style-pagination'>
                {pages > 1 ? (
                  <Pagination
                    count={count}
                    current={current}
                    getPage={this.getPage}
                    pages={pages}
                  />
                ) : (
                  <div className='row'>
                    <div className='col-xs-12'>
                      <nav className='pagination margin-top-triple margin-bottom-double' />
                    </div>
                  </div>
                )}
                <div className='datasheet-manager-pagination-size-selector'>
                  <Col xs={7}>{translate('pagination.size.selector')}</Col>
                  <Col xs={4}>
                    <SizeSelect
                      styles={colourStyles}
                      classNamePrefix='react-select'
                      onChange={(option) => this.getSize(option.value)}
                      options={PAGINATION_OPTIONS}
                      value={PAGINATION_OPTIONS.find((i) => i.value === size)}
                      menuPlacement='top'
                    />
                  </Col>
                </div>
              </Col>
            </Row>
          )}
          {this.renderWarningModal()}
          {this.renderWarningModalWeekly()}
          {renderError && this.renderNotification()}
          {renderExistentModal && this.renderExistentModal()}
        </Grid>
        <ToastContainer newestOnTop />



      </section>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = (state) => {
  const { scheduleBlockReducer, paginateReducer, weeklyBlockReducer, auth } = state

  return {
    scheduleBlocks: scheduleBlockReducer.list.records,
    updated: scheduleBlockReducer.save.updated,
    error: scheduleBlockReducer.save.error,
    deleted: scheduleBlockReducer.delete.deleted,
    deletedError: scheduleBlockReducer.delete.error,
    pages: paginateReducer.pages,
    count: paginateReducer.count,
    current: paginateReducer.current,
    weeklyBlock: weeklyBlockReducer.block,
    filters: scheduleBlockReducer.filters,
    accordionOpen: weeklyBlockReducer.accordionOpen,
    weeklyBlockError: weeklyBlockReducer.error,
    isUserMatriz: auth.isUserMatriz,
  }
}

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...scheduleBlockActions, ...weeklyBlockActions, ...spinnerActions },
    dispatch
  )

const ScheduleBlockTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(ScheduleBlockContainer)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleBlockTranslated)

export { ScheduleBlockContainer as ScheduleBlock }

